import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import {Modal as StandardModal} from "react-bootstrap"

import globalPadding from "@irati/ui/src/global/padding"
import {minWidthMedia} from "@irati/ui/src/global/media"
import Button, {IconButton, IconTypes} from "@irati/ui/src/Button"
import H3 from "@irati/ui/src/Headings/H3"
import {twoPxShadow} from "@irati/ui/src/global/elevation"
import {para} from "@irati/ui/src/Labels/css/labels"
import Loader from "@irati/ui/src/Loading/Loader"
import id from "@irati/utils/id"

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`

export const Overlay = styled.div`
  background-color: transparent;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`

export const ModalTitle = styled(H3)`
  padding-right: ${globalPadding.base};
`

export const ModalBody = styled.div`
  min-height: 25vh;
  max-height: 50vh;
  overflow-x: hidden;
  overflow-y: scroll;
  margin-top: ${globalPadding.base};
  margin-bottom: ${globalPadding.base};
  ::-webkit-scrollbar {
    background: transparent;
    width: 6px;
  }
  ::-webkit-scrollbar-thumb {
    background: #d8d8d8 !important;
    border-radius: 10px;
  }
`

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  align-items: center;
  ${minWidthMedia.tablet`
    flex-direction:row;
  `}
`

export const SecondaryButton = styled(Button)`
  width: 100%;
  margin-bottom: ${globalPadding.small};
  ${minWidthMedia.tablet`
    width:auto;
    margin-right: ${globalPadding.tiny};
    margin-bottom:0;
  `}
`

export const PrimaryButton = styled(Button)`
  width: 100% ${minWidthMedia.tablet`
    width:auto;
  `};
`

export const LoadingWrapper = styled.div`
  margin: auto;
  ${minWidthMedia.tablet`
      margin-right: ${globalPadding.large};
  `}
`

export const StyledStandardModal = styled(StandardModal)`
  .modal-content {
    padding: ${globalPadding.base};
    ${twoPxShadow};
    ${para};
    border-radius: 3px;
    border: none;
  }
`

const Modal = ({show, handleClose, children, primary, secondary, loading, title, ...props}) => {
  return (
    <StyledStandardModal show={show}>
      <ModalHeader>
        <ModalTitle>{title}</ModalTitle>
        <IconButton onClick={handleClose} icon={IconTypes.cross} />
      </ModalHeader>
      <ModalBody>
        {children}
        {loading && <Overlay />}
      </ModalBody>
      <ModalFooter>
        {loading && (
          <LoadingWrapper>
            {" "}
            <Loader />{" "}
          </LoadingWrapper>
        )}
        {secondary && (
          <Button tertiary disabled={loading} onClick={secondary.onClick} marginRight>
            {secondary.text}
          </Button>
        )}
        <PrimaryButton id={id("PrimaryButton", props)} disabled={loading} primary onClick={primary.onClick}>
          {primary.text}
        </PrimaryButton>
      </ModalFooter>
    </StyledStandardModal>
  )
}

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  primary: PropTypes.shape({
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired
  }).isRequired,
  secondary: PropTypes.shape({
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired
  })
}

export default Modal
